export class Constants {
    public static BASE_URL = 'https://setu.jetflix.ai/';
    // public static BASE_URL = 'http://localhost:3000/';

    public static QR_URL = 'https://setu.jetflix.ai:7000/qr'
    // public static QR_URL = 'http://localhost:7000/qr'
}
